import React from 'react';
import { connect } from "react-redux";
import Loader from '../Global/loader.js';
import './main.css';
import jwt from 'jsonwebtoken'
import clientLogin from './../API/Client/Login'
import Logo from './../images/Login-Logo.png'

export class Login extends React.Component{

    state={
        error: false,
        signin: false,
        username: "",
        password: ""
    }

    constructor(props) {
        super(props);
        document.title = 'Login';
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);        
    }


    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }



    handleSubmit= async (e) => {
        e.preventDefault()
        await this.setState({ signin: true })

        const login = await clientLogin(this.state.username,this.state.password, this.state.domain, "providerUser")
        if(login.error){
            this.setState({ error: login.error.response.data.responseMessage })
        }
        else{

            this.props.mapState("USER_MAP_CREDENTIALS", this.state.username)
            const token =jwt.sign({
                exp: Math.floor(Date.now() / 1000) + (60 * 30), // 30 min token
                data: login.data.token,
                role: "admin"
              }, process.env.REACT_APP_JWT_SALT);


            sessionStorage.setItem("token", token)
            this.props.mapState("USER_MAP_JWT",token)

            await this.props.mapState("USER_MAP_ROLE", "admin")
            this.props.history.replace("/Admin/dashboard/")

        }

        this.setState({ signin: false })
      
    }  

    componentDidMount(){    
        if (sessionStorage.getItem("token") !== null) {
            this.props.history.replace("/Admin/dashboard/")
            //window.location= "/dashboard/"            
        }       
    }
    
    render(){  
        const {signin, error} = this.state       

    return(
        
        <main className="admin_login" role="main">
                {signin ?
                    <Loader/>                                   
                :               
                
                    /*!this.props.userLoggedIn ?*/
                    <div className="login" style={{position: "absolute"}}> 
                        <img src={Logo} alt="logo" style={{width: "inherit", marginBottom: "20px"}}/>
                        <form className="form-signin">
                                <input 
                                    type="text" 
                                    id="username" 
                                    name="username" 
                                    placeholder="Korisničko ime" 
                                    defaultValue={this.state.username} 
                                    onChange={this.handleChange} 
                                />
                        
                                <input 
                                    type="password" 
                                    placeholder="Lozinka" 
                                    defaultValue={this.state.password} 
                                    onChange={this.handleChange}
                                    id="password" 
                                    name="password"                                 
                                />                            
                            { error ? 
                                <p className="error-color" style={{color: "red", fontSize: "20px"}}>{error}</p>
                            : null }
                            <br />         
                            <button 
                                className="btn btn-lg btn-primary btn-block"                                 
                                onClick={(e) =>this.handleSubmit(e)}
                                style={{fontSize: "20px"}}
                            > 
                                Prijava
                            </button>
                        </form>
                    </div>
                                        
                }   
        </main>
    )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
        authError: state.user.authError,
        jwtToken: state.user.jwtToken
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login);
